// src/utils/geocodeAddress.js

// ✅ Correct imports — use REAL cache functions
import { getCachedGeocode, saveGeocodeToCache } from "./geoCache";

const GOOGLE_API_KEY = "AIzaSyBYNqpl46EtcO0POvr7pt9vH1IdccZIs2M";

// ----------------------------------------------------
// GEOCODE FUNCTION
// ----------------------------------------------------
export async function geocodeAddress(address) {
  console.log("🌍 geocodeAddress CALLED with:", address);

  if (!address) return { lat: null, lng: null };

  const normalized = address.trim();
  if (!normalized) return { lat: null, lng: null };

  // 1️⃣ Try CACHE (LocalStorage + Firestore)
  const cached = await getCachedGeocode(normalized);
  if (cached) {
    console.log("⚡ CACHE HIT:", normalized, cached);
    return cached;
  }

  // 2️⃣ No cache → call Google API
  const url =
    `https://maps.googleapis.com/maps/api/geocode/json?address=` +
    encodeURIComponent(normalized) +
    `&key=${GOOGLE_API_KEY}`;

  console.log("🌍 Fetching URL:", url);

  try {
    const res = await fetch(url);
    console.log("🌍 API HTTP STATUS:", res.status);

    const data = await res.json();
    console.log("🌍 API RESPONSE:", data);

    // No results
    if (data.status !== "OK" || !data.results.length) {
      console.warn("⚠ ZERO_RESULTS OR ERROR for:", normalized);
      const empty = { lat: null, lng: null };
      await saveGeocodeToCache(normalized, empty);
      return empty;
    }

    // Extract coordinates
    const loc = data.results[0].geometry.location;
    const geo = { lat: loc.lat, lng: loc.lng };

    console.log("✅ GEOCODE SUCCESS:", normalized, geo);

    // Save to cache
    await saveGeocodeToCache(normalized, geo);

    return geo;

  } catch (err) {
    console.error("❌ Geocoding error:", err);
    return { lat: null, lng: null };
  }
}
